<template>
  <v-card class="mb-12" flat>
    <v-row>
      <v-col cols="12">
        <v-row style="text-align: center">
          <v-col cols="12">
            <h2 style="text-align: center">
              Selecciona la marca de tu vehículo
            </h2>
          </v-col>
        </v-row>

        <template v-if="loading">
          <v-row justify="center" class="text-center">
            <v-col cols="12">
              <v-progress-circular :size="100" :width="7" color="primary" indeterminate></v-progress-circular>
            </v-col>
          </v-row>
        </template>

        <template v-else>
          <v-row v-if="verTodas">
            <v-col cols="12">
              <v-select @change="seleccionarMarca" :items="marcas" item-text="marca" dense label="Selecciona la marca"
                return-object></v-select>
            </v-col>
          </v-row>
          
          <div v-if="!verTodas" class="estiloLogos part_sym">
            <div  @click="seleccionarMarca(marca)" :title="marca.marca" class="ng-star-inserted" v-for="(marca, i) in marcasMostrar" v-bind:key="i">
                <label class="ng-star-inserted">
                <picture>
                  <img  v-if="marca.marca=='VOLKSWAGEN'" src="@/assets/img/Volkswagen_logo_300x300.png" width="30%">
                  <img  v-if="marca.marca=='AUDI'" src="//logo.clearbit.com/audi.com" width="30%">
                  <img  v-if="marca.marca=='ALFA ROMEO'" src="//logo.clearbit.com/alfaromeo.mx" width="30%">
                  <img  v-if="marca.marca=='ACURA'" src="//logo.clearbit.com/spanish.acura.com" width="30%">
                  <img  v-if="marca.marca=='BMW'" src="//logo.clearbit.com/bmwusa.com" width="30%">
                  <img  v-if="marca.marca=='JAGUAR'" src="//logo.clearbit.com/jaguarmexico.com.mx" width="30%">
                  <img  v-if="marca.marca=='CHRYSLER'" src="//logo.clearbit.com/chrysler.com" width="30%">
                  <img  v-if="marca.marca=='INFINITI'" src="//logo.clearbit.com/infiniti.mx" width="30%">
                  <img  v-if="marca.marca=='FIAT'" src="//logo.clearbit.com/fiatusa.com" width="30%">
                  <img  v-if="marca.marca=='FORD'" src="@/assets/img/Ford_logo_300x300.png" width="30%">
                  <img  v-if="marca.marca=='HONDA'" src="//logo.clearbit.com/honda.mx" width="30%">
                  <img  v-if="marca.marca=='HYUNDAI'" src="//logo.clearbit.com/hyundai.ru" width="30%">
                  <img  v-if="marca.marca=='KIA'" src="@/assets/img/Kia_logo_300x300.png" width="30%">
                  <img  v-if="marca.marca=='LAND ROVER'" src="//logo.clearbit.com/landroverusa.com" width="30%">
                  <img  v-if="marca.marca=='MAZDA'" src="https://memolira.com/wp-content/uploads/2020/03/Mazda-logo.png" width="30%">
                  <img  v-if="marca.marca=='MBENZ'" src="//logo.clearbit.com/mercedes-benz.com.mx" width="30%">
                  <img  v-if="marca.marca=='MERCEDES BENZ'" src="//logo.clearbit.com/mercedes-benz.com.mx" width="30%">
                  <img  v-if="marca.marca=='MINI'" src="//logo.clearbit.com/mini.com" width="30%">
                  <img  v-if="marca.marca=='MITSUBISHI'" src="//logo.clearbit.com/mitsubishi.com" width="30%">
                  <img  v-if="marca.marca=='PEUGEOT'" src="//logo.clearbit.com/peugeot.com" width="30%">
                  <img  v-if="marca.marca=='RENAULT'" src="//logo.clearbit.com/renault.com.mx" style=" width:50% !important">
                  <img  v-if="marca.marca=='TESLA MOTORS'" src="//logo.clearbit.com/tesla.com" width  ="20%">
                  <img  v-if="marca.marca=='SEAT'" src="https://brandemia.org/contenido/subidas/2014/03/logo_principal_seat.jpg" width="30%">
                  <img  v-if="marca.marca=='SMART'" src="//logo.clearbit.com/mercedes-benz.com.mx" width="30%">
                  <img  v-if="marca.marca=='NISSAN'" src="@/assets/img/Nissan_logo_300x300.png" width="30%">
                  <img  v-if="marca.marca=='SUBARU'" src="//logo.clearbit.com/subaru.com" width="30%">
                  <img  v-if="marca.marca=='SUZUKI'" src="//logo.clearbit.com/suzukicycles.com" width="30%">
                  <img  v-if="marca.marca=='TOYOTA'" src="@/assets/img/Toyota_logo_300x300.png" width="30%">
                  <img  v-if="marca.marca=='BAIC'" src="//logo.clearbit.com/baic.cl" width="30%">
                  <img  v-if="marca.marca=='BUICK'" src="//logo.clearbit.com/buick.com.mx" width="30%">
                  <img  v-if="marca.marca=='BUIK'" src="//logo.clearbit.com/buick.com.mx" width="30%">
                  <img  v-if="marca.marca=='CADILLAC'" src="//logo.clearbit.com/cadillac.com/" width="30%">
                  <img  v-if="marca.marca=='CHEVROLET'" src="//logo.clearbit.com/chevrolet.com.mx" width="25%">
                  <img  v-if="marca.marca=='DODGE'" src="@/assets/img/Dodge_logo_300x300.png" width="30%">
                  <img  v-if="marca.marca=='GMOTORS'" src="//logo.clearbit.com/www.gm.com.mx" width="30%">
                  <img  v-if="marca.marca=='JEEP'" src="//logo.clearbit.com/jeep.com.mx" width="30%">
                  <img  v-if="marca.marca=='LINCOLN'" src="//logo.clearbit.com/lincoln.mx" width="30%">
                  <img  v-if="marca.marca=='LROVER'" src="//logo.clearbit.com/landrover.com.mx" width="30%">
                  <img  v-if="marca.marca=='PORSCHE'" src="//logo.clearbit.com/www.porsche.com" width="30%">
                  <img  v-if="marca.marca=='VOLVO'" src="//logo.clearbit.com/volvocars.com"  width="30%">
                  <img  v-if="marca.marca=='BENTLEY'" src="//logo.clearbit.com/bentleymotors.com"  width="30%">
                  <img  v-if="marca.marca=='FERRARI'" src="//logo.clearbit.com/ferrari.com"  width="30%">
                  <img  v-if="marca.marca=='MASERATI'" src="//logo.clearbit.com/maseratimexico.com"  width="30%">
                  <img  v-if="marca.marca=='ASTON MARTIN'" src="//logo.clearbit.com/www.astonmartin.com"  width="30%">
                  <img  v-if="marca.marca=='LOTUS'" src="//logo.clearbit.com/www.lotuscars.com"  width="30%">
                  <img  v-if="marca.marca=='HUMMER'" src="https://www.actualidadmotor.com/wp-content/uploads/2020/04/Hummer-new-logo.jpg"  width="10%">
                  <img  v-if="marca.marca=='FAW'" src="//logo.clearbit.com/fawcamiones.mx/"  width="30%">
                  <img  v-if="marca.marca=='PONTIAC'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACoCAMAAABt9SM9AAABOFBMVEX///8AAABlJRyqNCb8/Pzn5+ff39+sNSfW1tb19fVpaWlmJBzHx8fMzMxaWlokJCR6KyJjIx7v7+93d3eenp5+fn7R0dFnJBuMjIzm5uarq6uPj49KSkq6urqGiJalpaUWAAB6fYyipK2MjpvW192ytL8XFxeWmKRBQUG9vb1oa31jY2NPT08gICB2dnzMztVvcn8uLi4eAACKMymnqbWCg4spAABfYmx9gJE3NzenOi1ZIBoxOD26vMVxdIYtLS0RERVPT1g2FhMlAABBAAA+CwAAAApbX2eWNipUGBA7EQpGSVAMGx1zKSE2AAAvCACgeXXCr6xaEACoLRu0eHHLp6JnPDlDDgaiIQjk0Mx5WlqDb3GaIQqxYVeojYp7T0pVAACgRj2ZUk2RXVxxYmpnMzBmSEu7ioW4L3upAAAMzUlEQVR4nO2dC1vayBrHZzAJhABKAMNFgkmIwQsEa1JQBHR7eujqut3W7bZ7O2fv+/2/wZnJdcJNWqvxLPN7+jxqCMnLn5l/3nlnkgJAoVAoFAqFQqFQKBQKhUKhUFYgVap+7Fu4Wo15iFCePEVYLcDix3z27R1YLELxwSJ6uoiQB4CvwQK74hv22+06ekcn96BhPU2yF4Dn0M8qzKVW2L0Ij7YBYHTDaD10ZE8QEfWnnpJBv2VOjzPL9+VLsFBBP6o9Re0UHiW8J8bePlBHplFHvTF1BJd4feUQ1tBOrKrII1m9rj9eiE+HUgmY3SbgjCqybLYAF1znkKs30I+mofQ1oBrWWho82Eem1e0ge+dUteJ6/awO9fYebkmm3JeVAxEoqrH5+JE+AXjURmT5st3gxaaqYpOf9nqmCHPI1UFG6feV7jlkRGRZ5XiijZvNOqj2OzD/rGQOdcswQdTrxRIsoXbHDxVE9/zZFy1galbrjmvBP5VaGqQUG75Kbj2/1FRL1YbItVKHjkUBLgeLyNUrKmpV/d74xSDxr5pjWeuZwYMsBEzXPheSybOTl+e2Yaga9nrUosqZ03/jyyNydVmWJ+3XA0ESYBZZlrYTd9RxATmgKb2rjY2NZPLVl+2eZhgy9nqm6HQ2U5M1Tb68uMoLUkLKQ4ZVrHQx7qDjYqcBkCGhfojl2jjL705sQ+trTfwaM5SRdvb17lVeEhIJQRrsgKGmn27HHXRcFHOAU+SvTrBYuHWd3Ty7tlFjkpugLqu6ZZ8+G+SlhIP0dRGoqg7jjjk2OGRait0SXLFQ40qebb0+78iyJaq6bo+fY6sSXLESMAX6lrG2loVMKwWK/d5rTyyXk6txT2uqnfbVQPJaVSKRFwYQcLKebsQdcnzkiiDT90xrI2heyOsnu+8TUqgV6oVXOTA0hm0u7pDjo7oDKsi0tiJNC18aE3nc/wRCrOcNYFhrbFnYtBhg968HUbGQXDeJKHlkWYyslw/jjjhOUKKp9nsvzqbF2pKEiFhCHlmWoU/W2LIASNfQKDlqWg43UrRlSe/TYGgN26vUVP+xVI+BqMjjm42IWsmzb6SoWtKLKjD0tbYsAFjIA61/OUiSYiU3fn3zNtoNE5DlZd1Oxx1vvOzVwVDu7kZMK3n7beZtpGVJgwtgGvrRWlaUQ8oFkJLtKdP68M78znF4P30X3heAjhKHtawoh2Qg4GX5/CbSDT98b/7giCW5F0VBeFZHlqW24442ZhjIAkPOXQViJTdubz/wmR/fvkUe74olSAkoipq+npNgJKdVbFoQmdYtlunDT2c/f/sOmMX/fPPf/C+/IMlwVxycA1PVr/fjDjZuymnQlGV4ktw4+/nvd99zIi+ybEVssqLIs9k3WLNE4mUZVJFl8XEHGzfb2LTs8wTqh7/+9vvvP/5oK4pibI/wJMUff/zw13d/5gVpN4Mtay/uWOMHckCVJ7i2fIv+3W6cvfr1N93sfvfnQHLBWRYjGvq6ToKR7DRABptWUAHcuP3pjfkH9ndk8GgInUh82QKmpZ+u6SQYSS0NODmoLTvcvjP/IsY7uKJsrXd5xgdPiGl2iyjTJG//Nv8kxBLgNjCs9Z0EI3FMK1Jbvv15GA53BCkPQcXQc2s7CUZyVASmFi3TnL0hxRrkkGUNL9a4ohyCa8tG/6uTDaJO801Y/BNwRdmyLGpZmApkeFW+HkQqpcEMGJ6K5hhN7ax5ecYHZhld6z0jWlZyiyzPQMBpa7rgb5bDGjANZFqkWPloRdkw1r0841M9Bpwhj4kJsYhYz6tA1Ww61nFhIS9a8iWZaW35liWhLKvCa1qvFHeUTwW4z+tGd/csOSsWShz2kGXJ1x9958o/lXIBDC0y0yLFeo9e7GvUsnwyEJg6WVsmxEo8qwO1b9Msy4eBYlM3Lq+CCTHS4HFFuU8tK2Rcr+hWWKYhxBIGx7iSSrOskHKB13UbnsyKJb0sg6Fi0IpySBYy1lA7F5IznpXYzTCqYq/nbRXzYWBFHxpObXmqZeUhI2rKhFaUCVoN09KJ2rIvljBoAbPfH9OKMkHxkDOGYW05EAtXlIcjmSYOJBwUNTM0rbAbwm1eVZR1vHl1CTBj6NbkddTghQSuKKOxDq0oRziq6erQmcWPiIUryooGaUU5QuPUlE07uNnC7YaC9BxZFhIr7uieGBVojkzDX7cc5FmQ49V+Z63XKM8DNmRd771wkwdPLLeirNHyzDSFgmGYfpnG64a4omwqtKI8Q/1YV5r+zRa+Zz2vAl2h5ZkZRDg8CEzL6YY4caiIBi3PzGHPUPRhz1237IiVT7iWdb72C/5mKaU1zTctr2W9LziWRcszM9Q3jW5THt8QYr2oM/rIHscd2ROEh8aBqV5ehWIJkEeWRcsz8zjujCx3xJN0robSYAyairxJyzNzKF/KWlNxasuuWC/LwOzSsc5csqgfNjVn3bLTDaXdDKN3O6dxx/U0cUxrcnXmpw6QYQ3lshZ3WE+TU1txTCuJu6EkDVp4EqydjTusp0nxWpObysWJI1ZC+rpGK8qLSbmmlU863VCA27w16h7FHdVTBWoHpjX5whELl2cqhnK91reQLyPXU9RhB5kW7oaDQ5xl0YryIhrHstLs49oyMvivG2B4QMszC+FQP2xquEyDWhauKI96dI3yQqB9MNTxumUsFuBkhVaUF5OeKKpTptkScEV5RC1rCdWxpnD9za3klvSijixLoZa1mArOtHBteSsPWV7tTtb+FvJlQHuETGv3bGtwgSyrf04X/C2hMJEN04avTq5KwDyQaUV5GfW2oXDy+OZkd59BlkUX/C1DhCoyrcvBCa4ojyZ0Emwpe7YyHHZ3hXPQlJUxnQRbSimn4Vn8L8rUsu4mA41RRb6GWWY46tKK8nIYnGmpPciIKq0o38lpZ4RMawc/66G9ts9RXpXadV9rdhugeUAnwe4ET4ixdpYfjjr0qRd3gk3Lyohqf0LXKN9JqyPrzTqraOv9UNLVKLZUTcxy1LJWIQWtA5ZFlrWO/4HaR4PSUhNZ1hGtKK9AridbfJfeVrES1bEhs9SyVqMCjS6yLDoJthLQ1kb0qRcrUrg2RvSpFyvCwtYlpPM6K8IVDmknpFAoFAqFQqFQKBTK/zOiKPIiz6z6v4NzmWqxjGlUM6mppTBMwMzbvI3MXYT7zDv5kpeCj5PK7lcx9WyWYz/3Wp0duIhWaeq23Gy5NbXLRbpKxEO8MDUxmMHb0M/CwpN5p0T75NxfZ1dD8P5eCx7GzDUK49lDftb53NzS6MNbApnagl0Og+kHcmtULV+s0h1i4Tmy9LwDYMaR3aYQF4X3iGJBv3FVgy3jNO6FhaNwH7+aF3lj5MOu2rJ2loh1SOw3c9s+8S1stnaOjlqbew8oFhf1Dj7ld093L+8TwNZ+2O3Eqt8rj5lArHrbD5rsR75YYoUNEDe9M4ebKuJisZyWE2gSXRhe8TfXUqShichgy591CbknVmXmBe/8TtPyg5xeCZohWoT7ju3AWUi1fLEieN1q2oTni+UcoRE2TXLqUfS2PXy9Ojd7chev2eMqcArO/7bD79T5/vAv2SB0Uq25Ym1+hFgVX4xT/+DE23YeS6vFYuVCsTzd5q1tLLovOQ+FdMWap9Z9xWKCcwQNN1yVynlbPuJDfyoLxfJCyIa/zstafGUYEIgF2Bm17itWK9zRb+UwmKotTv39gCwQS/SvdiD4NuenN95uLAjFItqWl3rcU6wCGWFwXfavc56hPsaDbXJhbHAOuBd6n33+cmxvvwogxCLalvv3/cRq4L/Dq1pg8l5a8/hi4Q4zRyvn22OWtCxfFh6QYk2rdS+xstNSBIMO1vnTS0cfY+42F36maaXaJTeaZZ7ldYpNfzc/5Y+qdR+xnHaNnwGR2c+41P1Du1/fPhHCA0OIxUVgw/zOa/jzroZkCyTFChNFvOk+Yu15qhSnv0vo5Xdew5+T2Hx2PLGWPsrKvwLN7kRcBqbEItTK3Ecs5wwi/h9e5+HcXFZ+tKa1iljBaKcWLY9k/AGYe6WKihXkP2jj9ieLVfIOyl+0N0n8QzsrJ7wh1uaDt62VxAoT53Q1hatEPJuqh4NX76o+JVaYErljuuljriKWY4nzxsLByfF+vF+QOC1mCfdAY8Niob1qpW4VVhNrWb0guFBNi0Wo9YliOQeYn21Gxz3RAk27Pd4MBvQraLAyK4oFuPlytarhNzcjVlSt6SPeLZaTDS+42y4Y97hWxRfnFP4+u1ieRa9yZ2m2mD69CILYa6WLmcgnnSN6aknUZMsgCBM/5mLe60E0/nH9R0uJ+7XDGcX2Llb4YA8Ij8v2j3GiT3MbnmUrKPOpsOzjREmhUCgUCoVCoVAoFAqFQvlM/A/T8Uo2MESdCwAAAABJRU5ErkJggg=="  width="30%">
                  <img  v-if="marca.marca=='SAAB'" src="https://marcasdecoches.info/wp-content/uploads/2020/05/Saab-Logo-2000.jpg?ezimgfmt=rs:380x327/rscb1/ngcb1/notWebP"  width="20%">
                  <img  v-if="marca.marca=='GMC'" src="//logo.clearbit.com/gmc.com.mx" width="30%">
                  <img  v-if="marca.marca=='JAC'" src="//logo.clearbit.com/jacmotors.com.co/" width="30%">
                  <img  v-if="marca.marca=='INTERNATIONAL'" src="//logo.clearbit.com/internationaltrucks.com" width="30%">
                  <img  v-if="marca.marca=='FREIGHTLINER'" src="//logo.clearbit.com/freightliner.com.mx/" width="30%">
                  <img  v-if="marca.marca=='GENERAL MOTORS'" src="//logo.clearbit.com/www.gm.com.mx" width="30%">
                </picture>
                </label>
              <span class="ng-star-inserted">{{marca.marca}}</span>
            </div>
          </div>
          <v-row v-if="!verTodas" style="padding-top:2%"  justify="center" class="text-center">
            <v-col cols="12">
              <v-btn :depressed="true"   elevation="2" class="mr-2" color="primary" @click="verTodas = !verTodas" >Ver Todas</v-btn>
            </v-col>
          </v-row>
        </template>

        <v-row justify="center" class="text-center">
          <v-col cols="12">
            <v-btn text outlined elevation="2" class="mr-2" @click="$emit('back', 'modelo')">Regresar</v-btn>
            <v-btn color="primary" v-if="verTodas" @click="verTodas = !verTodas">Ver Principales</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>

</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ["modelo"],
  data: () => ({
    marcas: [],
    marcasMostrar: [],
    marcasFamosos:[
      {
        id: 52,
        marca: 'CHEVROLET'
      },
      {
        id: 5,
        marca: 'CHRYSLER'
      },
      {
        id: 69,
        marca: 'DODGE'
      },
      {
        id: 8,
        marca: 'FORD'
      },
      {
        id: 10,
        marca: 'HONDA'
      },
      {
        id: 56,
        marca: 'KIA'
      },
      {
        id: 16,
        marca: 'MAZDA'
      },
      {
        id: 19,
        marca: 'NISSAN'
      },
      {
        id: 22,
        marca: 'RENAULT'
      },
      {
        id: 25,
        marca: 'SEAT'
      },
      {
        id: 29,
        marca: 'TOYOTA'
      },
      {
        id: 30,
        marca: 'VOLKSWAGEN'
      },
    ],
    marcasFamososGNP:[
      {
        id: 'GM',
        marca: 'CHEVROLET'
      },
      {
        id: 'CH',
        marca: 'CHRYSLER'
      },
      {
        id: 'FR',
        marca: 'FORD'
      },
      {
        id: 'HO',
        marca: 'HONDA'
      },
      {
        id: 'KI',
        marca: 'KIA'
      },
      {
        id: 'MA',
        marca: 'MAZDA'
      },
      {
        id: 'NI',
        marca: 'NISSAN'
      },
      {
        id: 'RE',
        marca: 'RENAULT'
      },
      {
        id: 'SE',
        marca: 'SEAT'
      },
      {
        id: 'TO',
        marca: 'TOYOTA'
      },
      {
        id: 'VW',
        marca: 'VOLKSWAGEN'
      },
    ],
    verTodas: false,
    marcaSeleccionada: null,
    loading: false,
  }),
  computed: {
    ...mapState(['aseguradoraMeta', 'abandono'])
  },
  mounted() {
    this.loading = true;
    let aseguradora = "qualitas"
    if (this.aseguradoraMeta.name != null) {
      aseguradora = this.aseguradoraMeta.aseguradora;
    }

    if(this.aseguradoraMeta.aseguradora == 'gnp'){
        this.marcasMostrar = this.marcasFamososGNP
      }else{
        this.marcasMostrar = this.marcasFamosos
      }
      console.log(this.marcasMostrar);
      
    this.axios.get(`v1/vehiculo/${aseguradora}/marca/${this.modelo}`).then((response) => {
      this.loading = false;
      this.marcas = response.data;
      console.log(this.marcas);
    }).catch((exception) => {
      console.error(exception)
      this.loading = false;
    });
  },
  methods: {
    async log(row) {
      try {
        this.axios.post('/v1/web/log', {
          id: this.abandono,
          landing: this.aseguradoraMeta.aseguradora,
          paso: 'marca',
          valores: [{ marca: row }],
          fuente: this.$route.query.fuente
        }
        )
      } catch (exception) {
        console.error(exception);
      }
    },
    seleccionarMarca(marca) {
      this.log(marca.marca);
      this.$emit('seleccionarMarca', marca);
    }
  }
};
</script>

<style scoped>

.estiloLogos {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: auto;
    margin-left: auto;
    width: 50%;
    justify-content: left;
}

.estiloLogos div {
    width: 100px;
    height: auto;
    margin: 5px 10px;
    text-align: center;
}

.estiloLogos div label {
    width: 100px;
    height: 79px;
    border: 1px solid #ccc;
    display: table-cell;
    cursor: pointer;
    vertical-align: middle;
}

.estiloLogos div label img {
    width: 70%;
}

</style>